import React from 'react';
import { useLocation } from 'react-router-dom';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import logo1 from '../../assets/logo/brix logo1.png';
import { Box, Typography, Paper, Button } from "@mui/material";
import axios from 'axios';
import { BASEURL } from '../../constants/Common';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';


const PreviewPage = () => {
  const location = useLocation();
  const {
    logo,
    rows,
    orgId,
    paymentTerms,
    taxIdentificationNumber,
    businessName,
    businessAddress,
    businessCity,
    businessEmail,
    businessPhone,
    clientName,
    clientAddress,
    clientCity,
    clientEmail,
    invoiceNumber,
    invoiceDate,
    hstRegistration,
    businessRegistration,
    paymentOption,
    totalWithoutTax,
    clientPhone,
    totalTax,
    totalWithTax,
    customTaxTotals,
  } = location.state || {};



  const convertImageToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };

  // Render the same invoice as in the download function
  const renderInvoice = () => {
    // Calculate totals


    const doc = new jsPDF();

    // Set up header
    doc.setFontSize(20);
    doc.setFont('helvetica', 'bold');
    doc.text('Invoice', 202, 11, { align: 'right' });

    doc.setFont('helvetica', 'normal');
    // Draw the first horizontal line, moving it down
    doc.setLineWidth(0.5);
    doc.line(10, 48, doc.internal.pageSize.width - 10, 48);  // Move the line lower down, y = 30

    // Draw the second horizontal line below the first one
    doc.line(10, 49, doc.internal.pageSize.width - 10, 49);  // Second line, y = 35

    //Check if a logo is uploaded and add it to the left side of the business details
    if (logo) {
      const logo2Width = 30; // Adjust the width as needed
      const logo2Height = 20; // Adjust the height as needed
      // const logo2X = 10; // Left margin for the logo
      // const logo2Y = 10; // Top margin for the logo
      const logo2X = doc.internal.pageSize.width - logo2Width - 10; // Right side, with 10px margin
      const logo2Y = 20; // Just below the "Invoice" label

      doc.addImage(URL.createObjectURL(logo), 'PNG', logo2X, logo2Y, logo2Width, logo2Height);
    }

    // if (logo instanceof File) {
    //   convertImageToBase64(logo)
    //     .then((base64Logo: any) => {
    //       doc.addImage(base64Logo, 'PNG', 10, 10, 30, 20);
    //     })
    //     .catch((err: any) => console.error('Error converting image:', err));
    // } else if (typeof logo === 'string'){
    //   doc.addImage(logo, 'PNG', 10, 10, 30, 20);
    // }

    if (logo && typeof logo === "object" && logo instanceof File) {
      // Ensure it's a valid image file
      if (logo.type.startsWith("image/")) {
        convertImageToBase64(logo)
          .then((base64Logo) => {
            doc.addImage(base64Logo, "PNG", 10, 10, 30, 20);
          })
          .catch((err) => console.error("Error converting image:", err));
      } else {
        console.error("Invalid file type for logo.");
      }
    } else if (typeof logo === "string" && logo.startsWith("data:image")) {
      // Check if it's already a Base64 string
      doc.addImage(logo, "PNG", 10, 10, 30, 20);
    } else {
      console.warn("Invalid logo format. Skipping logo rendering.");
    }


    // Add Business Details next to the logo
    const businessDetailsX = 10; // Position details next to the logo
    // Add Brix Technologies Ltd. details on the left side of the header
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.text(`${businessName}`, businessDetailsX, 10);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text(`${businessAddress}`, businessDetailsX, 15);
    doc.text(`${businessCity}`, businessDetailsX, 20);
    doc.text(`${businessEmail}`, businessDetailsX, 25);
    doc.text(`${businessPhone}`, businessDetailsX, 30);
    // doc.text(`${hstRegistration}`, businessDetailsX, 35);
    // doc.text(`${businessRegistration}`, businessDetailsX, 40);
    // doc.text(`${taxIdentificationNumber}`, businessDetailsX, 45);

    // doc.text('HST Registration:', doc.internal.pageSize.width - 75, 35);
    // doc.text('Business Registration:', doc.internal.pageSize.width - 75, 40);
    // doc.text('Tax Identification Number:', doc.internal.pageSize.width - 75, 45);

    // Add Client Information on the left side, just below the header
    // "Bill To:" in bold and size 12

    // Properly align HST Registration, Business Registration, and Tax ID Number labels and values
    const labelX1 = businessDetailsX;
    const valueX = businessDetailsX + 50; // Adjust spacing for alignment

    doc.setFont('helvetica', 'bold');
    doc.text('HST Registration:', labelX1, 35);
    doc.text('Business Registration:', labelX1, 40);
    doc.text('Tax Identification Number:', labelX1, 45);

    doc.setFont('helvetica', 'normal');
    doc.text(`${hstRegistration}`, valueX, 35);
    doc.text(`${businessRegistration}`, valueX, 40);
    doc.text(`${taxIdentificationNumber}`, valueX, 45);
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('Bill To:', 10, 60); // Bold text for "Bill To:"

    // Client name, address, and city in normal and size 10
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(`${clientName}`, 35, 60); // Client name next to "Bill To:"
    doc.text(`${clientAddress}`, 35, 65); // Client address
    doc.text(`${clientCity}`, 35, 70);    // Client city
    doc.text(`${clientEmail}`, 35, 75);
    doc.text(`${clientPhone}`, 35, 80);

    doc.setFont('helvetica', 'bold');
    // Add Client's City on the right side of Client Information
    doc.text('Invoice Number:', doc.internal.pageSize.width - 75, 60);
    doc.text('Invoice Date:', doc.internal.pageSize.width - 75, 66);
    doc.text('Payment Option:', doc.internal.pageSize.width - 75, 72);
    doc.setFont('helvetica', 'normal');
    doc.text(`${invoiceNumber}`, doc.internal.pageSize.width - 30, 60);
    //  doc.text(` ${invoiceDate?.toLocaleDateString()}`, doc.internal.pageSize.width - 30, 66);
    // Format the invoiceDate as 'Jan/08/2025' or 'Jan-08-2025'
    const formattedInvoiceDate = invoiceDate
      ? new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      }).format(new Date(invoiceDate))
      : '';

    doc.text(`${formattedInvoiceDate.replace('/', '-')}`, doc.internal.pageSize.width - 30, 66);

    doc.text(`${paymentOption}`, doc.internal.pageSize.width - 30, 72);

    // Add Table with Invoice Items
    const tableData = rows.map((row: any) => [
      row.description,
      row.quantity,
      row.unitPrice.toFixed(2),
      row.tax,
      row.taxPercentage,
      row.amount.toFixed(2),
    ]);

    // Create the table
    (doc as any).autoTable({
      startY: 120, // Position where the table will start
      head: [['Description', 'Quantity', 'Unit Price', 'Tax', 'Tax(%)', 'Amount']],
      body: tableData,
      theme: 'grid',
    });

    // Access the lastAutoTable property by casting the doc to `any`
    //    const lastY = (doc as any).lastAutoTable.finalY;

    //    // Add Total Row aligned to the right
    // const pageWidth = doc.internal.pageSize.width; // Get the page width
    // const margin = 30; // Set a margin for spacing from the edge

    // // Add Total Row aligned to the right with labels and values in two columns
    // const startX = pageWidth - 30; // Starting X-coordinate for the values
    // const labelX = pageWidth - 100; // X-coordinate for the labels
    // const startY = lastY + 10; // Starting Y-coordinate for totals section

    // doc.setFontSize(10); // Set a smaller font size for clarity

    // // Add totals with proper alignment
    // doc.setFont('helvetica', 'bold');
    // doc.text('Total without Tax :', labelX, startY);
    // doc.text(totalWithoutTax.toFixed(2), startX, startY, { align: 'right' });

    // doc.text('HST :', labelX, startY + 10);
    // doc.text(totalTax.toFixed(2), startX, startY + 10, { align: 'right' });

    // doc.text('GST :', labelX, startY + 20);
    // doc.text(totalTax.toFixed(2), startX, startY + 20, { align: 'right' });

    // doc.text('Total with Tax :', labelX, startY + 30);
    // doc.text(totalWithTax.toFixed(2), startX, startY + 30, { align: 'right' });

    // // Optionally, draw horizontal lines for better separation
    // doc.setLineWidth(0.2);
    // doc.line(labelX, startY + 3, startX + 20, startY + 3); // Line after "Total without HST"
    // doc.line(labelX, startY + 13, startX + 20, startY + 13); // Line after "HST"
    // doc.line(labelX, startY + 23, startX + 20, startY + 23); // Line after "Total with HST"


    // Access the last Y-position of the table
    const lastY = (doc as any).lastAutoTable.finalY;
    const pageWidth = doc.internal.pageSize.width; // Get the page width

    const startX = pageWidth - 30; // X-coordinate for values
    const labelX = pageWidth - 100; // X-coordinate for labels
    let currentY = lastY + 10; // Start below the table

    doc.setFontSize(10); // Use a smaller font size for clarity

    // Add "Total without Tax"
    doc.setFont('helvetica', 'bold');
    doc.text('Total without Tax :', labelX, currentY);
    doc.text(totalWithoutTax.toFixed(2), startX, currentY, { align: 'right' });

    // Draw horizontal line below "Total without Tax"
    doc.setLineWidth(0.2);
    doc.line(labelX, currentY + 2, startX + 20, currentY + 2); // Adjusted width

    // Move Y position down for custom tax fields
    currentY += 6;

    Object.entries(customTaxTotals).forEach(([taxName, taxAmount]) => {
      const taxValue = Number(taxAmount); // Ensure taxAmount is treated as a number

      doc.text(`${taxName} :`, labelX, currentY);
      doc.text(taxValue.toFixed(2), startX, currentY, { align: 'right' });

      // Draw horizontal line below each tax amount
      doc.line(labelX, currentY + 2, startX + 20, currentY + 2); // Extended line

      currentY += 7; // Move down for the next entry
    });

    // Add final total amount text
    doc.text('Total with Tax :', labelX, currentY);
    doc.text(totalWithTax.toFixed(2), startX, currentY, { align: 'right' });

    // Draw horizontal line below "Total with Tax"
    doc.line(labelX, currentY + 5, startX + 20, currentY + 5); // Adjusted positioning

    // Move Y position down for Payment Terms
    currentY += 25; // Space after total

    // Add Payment Terms at the left corner
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.text('Payment Terms:', 18, currentY); // Left-aligned

    // Add actual payment terms details (adjust text accordingly)
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    const labelWidth = doc.getTextWidth('Payment Terms:') + 23;
    doc.text(paymentTerms, labelWidth, currentY); // Position details below label
    // Add Footer
    const footerHeight = 20; // Space reserved for footer
    const pageHeight = doc.internal.pageSize.height;

    const addFooter = () => {
      // Draw horizontal line
      doc.setLineWidth(0.5);
      doc.line(10, pageHeight - footerHeight, doc.internal.pageSize.width - 10, pageHeight - footerHeight);

      // Add copyright text on the left side
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      doc.text('Copyright © 2025 Brix Technologies Ltd.', 10, pageHeight - footerHeight + 9); // Position it on the left side of the footer

      // Add logo (replace '/path/to/logo.png' with your actual logo path)
      const logoWidth = 10;
      const logoHeight = 7; // Adjust dimensions as needed
      const logoX = doc.internal.pageSize.width - logoWidth - 20; // Position logo at the right
      const logoY = pageHeight - footerHeight + 5;

      doc.addImage(logo1, 'PNG', logoX, logoY, logoWidth, logoHeight);

      // Add website URL below the logo
      const urlX = doc.internal.pageSize.width - logoWidth - 29;
      const urlY = logoY + logoHeight + 5;  // Position URL below the logo with a small gap
      doc.text('https://brixpro.com', urlX, urlY); // Position the URL below the logo
    };

    addFooter();


    //  handleGenerateInvoice()
    // return doc.output('datauristring');
    return doc.output('blob'); // Return Blob for sending email


  };

  const rowsData = rows.map((row: any, index: any) => ({
    sno: index + 1,
    description: row.description,
    quantity: row.quantity,
    unitPrice: row.unitPrice,
    tax: row.tax,
    taxPercentage: row.taxPercentage,
    amount: row.amount,
  }));






  const handleGenerateInvoice = async () => {

    const status = "created";
    // Collect the necessary data for sending the email
    const invoiceData = {
      orgId,
      paymentTerms,
      taxIdentificationNumber,
      invoiceNumber,
      clientName,
      businessAddress,
      businessCity,
      businessEmail,
      businessPhone,
      clientPhone,
      totalWithoutTax,
      totalTax,
      totalWithTax,
      rows: JSON.stringify(rowsData),
      invoiceDate: dayjs(invoiceDate).format('YYYY-MM-DD'),
      hstRegistration,
      businessRegistration,
      paymentOption,
      businessName,
      clientAddress,
      clientCity,
      clientEmail,
      status,
      logo,

    };

    try {
      const response = await axios.post(BASEURL + '/create-invoice-email/', invoiceData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.status === 200) {
        toast.success('Invoice saved successfully.');
      } else {
        toast.error('Failed to save invoice.');
      }
    } catch (error) {
      console.error('Error in saving:', error);
      toast.error('Something went wrong. Please contact support.');
    }
  };

  const handleSendEmail = async () => {
    try {
      if (!clientEmail) {
        toast.error('Client email is required.');
        return;
      }
      
      if (!businessEmail) {
        toast.error('Business email is required.');
        return;
      }
      const formattedDate = dayjs(invoiceDate).format('YYYY-MM-DD');
      // Generate the invoice PDF as a Blob
      const pdfBlob = renderInvoice();

      // Prepare FormData to send the PDF and other details
      const formData = new FormData();
      formData.append('pdf', pdfBlob, `Invoice-${invoiceNumber}.pdf`); // Attach the PDF
      formData.append('clientEmail', clientEmail); // Recipient email
      formData.append('subject', `Invoice #${invoiceNumber}`); // Email subject
      formData.append('body', 'Please find your invoice attached.'); // Email body

      // Append additional business and client details to the FormData
      formData.append('businessName', businessName);
      formData.append('businessAddress', businessAddress);
      formData.append('businessCity', businessCity);
      formData.append('businessEmail', businessEmail);
      formData.append('businessPhone', businessPhone);
      formData.append('clientPhone', clientPhone);
      formData.append('clientName', clientName);
      formData.append('clientAddress', clientAddress);
      formData.append('clientCity', clientCity);
      formData.append('invoiceNumber', invoiceNumber);
      formData.append('invoiceDate', formattedDate);
      formData.append('hstRegistration', hstRegistration);
      formData.append('businessRegistration', businessRegistration);
      formData.append('paymentTerms', paymentTerms);
      formData.append('taxIdentificationNumber', taxIdentificationNumber);
      formData.append('paymentOption', paymentOption);
      formData.append('totalWithoutTax', totalWithoutTax);
      formData.append('totalTax', totalTax);
      formData.append('totalWithTax', totalWithTax);
      formData.append('status', "sent");
      formData.append('orgId', orgId);
      formData.append('logo', logo);

      // Append the formatted rows data to FormData
      formData.append('rows', JSON.stringify(rowsData));

      // Make the POST request to the backend
      const response = await axios.post(BASEURL + '/create-invoice-email/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data', // Ensure multipart format
        },
      });

      if (response.status === 200) {
        toast.success('Email sent successfully');
      } else {
        toast.error('Failed to send email.');
      }
    } catch (error) {
      console.error('Error sending email:', error);
      toast.error('Something went wrong. Please contact support.');
    }
  };




  const downloadInvoice = () => {
    // Calculate totals
    const totalWithoutTax = rows.reduce((total: any, row: any) => total + row.quantity * row.unitPrice, 0);
    const totalTax = rows.reduce(
      (total: any, row: any) => total + row.quantity * row.unitPrice * (row.taxPercentage / 100),
      0
    );
    const totalWithTax = totalWithoutTax + totalTax;

    const doc = new jsPDF();

    // Set up header
    doc.setFontSize(20);
    doc.setFont('helvetica', 'bold');
    doc.text('Invoice', 202, 11, { align: 'right' });

    doc.setFont('helvetica', 'normal');
    // Draw the first horizontal line, moving it down
    doc.setLineWidth(0.5);
    doc.line(10, 48, doc.internal.pageSize.width - 10, 48);  // Move the line lower down, y = 30

    // Draw the second horizontal line below the first one
    doc.line(10, 49, doc.internal.pageSize.width - 10, 49);
    // Check if a logo is uploaded and add it to the left side of the business details
    if (logo) {
      const logo2Width = 30; // Adjust the width as needed
      const logo2Height = 20; // Adjust the height as needed
      // const logo2X = 10; // Left margin for the logo
      // const logo2Y = 10; // Top margin for the logo
      const logo2X = doc.internal.pageSize.width - logo2Width - 10; // Right side, with 10px margin
      const logo2Y = 20;
      doc.addImage(URL.createObjectURL(logo), 'PNG', logo2X, logo2Y, logo2Width, logo2Height);
    }

    // Add Business Details next to the logo
    const businessDetailsX = 10; // Position details next to the logo
    // Add Brix Technologies Ltd. details on the left side of the header
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.text(`${businessName}`, businessDetailsX, 10);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text(`${businessAddress}`, businessDetailsX, 15);
    doc.text(`${businessCity}`, businessDetailsX, 20);
    doc.text(`${businessEmail}`, businessDetailsX, 25);
    doc.text(`${businessPhone}`, businessDetailsX, 30);
    // doc.text(`${hstRegistration}`, businessDetailsX, 35);
    // doc.text(`${businessRegistration}`, businessDetailsX, 40);
    // doc.text(`${taxIdentificationNumber}`, businessDetailsX, 45);

    // Add Client Information on the left side, just below the header
    // "Bill To:" in bold and size 12
    const labelX1 = businessDetailsX;
    const valueX = businessDetailsX + 50; // Adjust spacing for alignment

    doc.setFont('helvetica', 'bold');
    doc.text('HST Registration:', labelX1, 35);
    doc.text('Business Registration:', labelX1, 40);
    doc.text('Tax Identification Number:', labelX1, 45);

    doc.setFont('helvetica', 'normal');
    doc.text(`${hstRegistration}`, valueX, 35);
    doc.text(`${businessRegistration}`, valueX, 40);
    doc.text(`${taxIdentificationNumber}`, valueX, 45);


    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('Bill To:', 10, 60); // Bold text for "Bill To:"

    // Client name, address, and city in normal and size 10
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(`${clientName}`, 35, 60); // Client name next to "Bill To:"
    doc.text(`${clientAddress}`, 35, 65); // Client address
    doc.text(`${clientCity}`, 35, 70);    // Client city
    doc.text(`${clientEmail}`, 35, 75);
    doc.text(`${clientPhone}`, 35, 80);

    doc.setFont('helvetica', 'bold');
    // Add Client's City on the right side of Client Information
    doc.text('Invoice Number:', doc.internal.pageSize.width - 75, 60);
    doc.text('Invoice Date:', doc.internal.pageSize.width - 75, 66);
    doc.text('Payment Option:', doc.internal.pageSize.width - 75, 72);
    doc.setFont('helvetica', 'normal');
    doc.text(`${invoiceNumber}`, doc.internal.pageSize.width - 30, 60);
    // doc.text(` ${invoiceDate?.toLocaleDateString()}`, doc.internal.pageSize.width - 30, 66);
    // Format the invoiceDate as 'Jan/08/2025' or 'Jan-08-2025'
    const formattedInvoiceDate = invoiceDate
      ? new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      }).format(new Date(invoiceDate))
      : '';

    doc.text(`${formattedInvoiceDate.replace('/', '-')}`, doc.internal.pageSize.width - 30, 66);
    doc.text(`${paymentOption}`, doc.internal.pageSize.width - 30, 72);

    // Add Table with Invoice Items
    const tableData = rows.map((row: any) => [
      row.description,
      row.quantity,
      row.unitPrice.toFixed(2),
      row.tax,
      row.taxPercentage,
      row.amount.toFixed(2),
    ]);

    // Create the table
    (doc as any).autoTable({
      startY: 120, // Position where the table will start
      head: [['Description', 'Quantity', 'Unit Price', 'Tax', 'Tax(%)', 'Amount']],
      body: tableData,
      theme: 'grid',
    });

    // Access the lastAutoTable property by casting the doc to `any`
    const lastY = (doc as any).lastAutoTable.finalY;

    // Add Total Row aligned to the right
    const pageWidth = doc.internal.pageSize.width; // Get the page width
    const margin = 30; // Set a margin for spacing from the edge

    // Add Total Row aligned to the right with labels and values in two columns
    const startX = pageWidth - 30; // Starting X-coordinate for the values
    const labelX = pageWidth - 100; // X-coordinate for the labels
    const startY = lastY + 10; // Starting Y-coordinate for totals section

    // doc.setFontSize(10); // Set a smaller font size for clarity

    // // Add totals with proper alignment
    // doc.setFont('helvetica', 'bold');
    // doc.text('Total without Tax :', labelX, startY);
    // doc.text(totalWithoutTax.toFixed(2), startX, startY, { align: 'right' });

    // doc.text('HST :', labelX, startY + 10);
    // doc.text(totalTax.toFixed(2), startX, startY + 10, { align: 'right' });

    // doc.text('GST :', labelX, startY + 20);
    // doc.text(totalTax.toFixed(2), startX, startY + 20, { align: 'right' });

    // doc.text('Total with Tax :', labelX, startY + 30);
    // doc.text(totalWithTax.toFixed(2), startX, startY + 30, { align: 'right' });


    //     // Add Payment Terms aligned to the left
    // doc.setFont('helvetica', 'bold');
    // doc.text('Payment Terms :', labelX, startY + 40);
    // doc.setFont('helvetica', 'normal');
    // doc.text(paymentTerms, 40, startY + 40);

    // // Optionally, draw horizontal lines for better separation
    // doc.setLineWidth(0.2);
    // doc.line(labelX, startY + 3, startX + 20, startY + 3); // Line after "Total without HST"
    // doc.line(labelX, startY + 13, startX + 20, startY + 13); // Line after "HST"
    // doc.line(labelX, startY + 23, startX + 20, startY + 23); // Line after "Total with HST"

    let currentY = startY;

    // Add "Total without Tax"
    doc.setFont('helvetica', 'bold');
    doc.text('Total without Tax :', labelX, currentY);
    doc.text(totalWithoutTax.toFixed(2), startX, currentY, { align: 'right' });
    doc.setLineWidth(0.2);
    doc.line(labelX, currentY + 2, startX + 20, currentY + 2);

    currentY += 6;

    // Add custom taxes
    Object.entries(customTaxTotals).forEach(([taxName, taxAmount]) => {
      const taxValue = Number(taxAmount);
      doc.text(`${taxName} :`, labelX, currentY);
      doc.text(taxValue.toFixed(2), startX, currentY, { align: 'right' });
      doc.line(labelX, currentY + 2, startX + 20, currentY + 2);
      currentY += 7;
    });

    // Add final total amount text
    doc.text('Total with Tax :', labelX, currentY);
    doc.text(totalWithTax.toFixed(2), startX, currentY, { align: 'right' });
    doc.line(labelX, currentY + 5, startX + 20, currentY + 5);

    // Move Y position down for Payment Terms
    currentY += 25; // Space after total

    // Add Payment Terms at the left corner
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.text('Payment Terms:', 18, currentY); // Left-aligned

    // Add actual payment terms details (adjust text accordingly)
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    const labelWidth = doc.getTextWidth('Payment Terms:') + 23;
    doc.text(paymentTerms, labelWidth, currentY); // Position details below label

    // Add Footer
    const footerHeight = 20; // Space reserved for footer
    const pageHeight = doc.internal.pageSize.height;

    const addFooter = () => {
      // Draw horizontal line
      doc.setLineWidth(0.5);
      doc.line(10, pageHeight - footerHeight, doc.internal.pageSize.width - 10, pageHeight - footerHeight);

      // Add copyright text on the left side
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      doc.text('Copyright © 2025 Brix Technologies Ltd.', 10, pageHeight - footerHeight + 9); // Position it on the left side of the footer

      // Add logo (replace '/path/to/logo.png' with your actual logo path)
      const logoWidth = 10;
      const logoHeight = 7; // Adjust dimensions as needed
      const logoX = doc.internal.pageSize.width - logoWidth - 20; // Position logo at the right
      const logoY = pageHeight - footerHeight + 5;

      doc.addImage(logo1, 'PNG', logoX, logoY, logoWidth, logoHeight);

      // Add website URL below the logo
      const urlX = doc.internal.pageSize.width - logoWidth - 29;
      const urlY = logoY + logoHeight + 5;  // Position URL below the logo with a small gap
      doc.text('https://brixpro.com', urlX, urlY); // Position the URL below the logo
    };

    addFooter();

    //     // Save the PDF
    doc.save('invoice.pdf');

    // handleGenerateInvoice()




  };



  return (
    <Box sx={{ ml: '-24px', mt: '-95px' }}>
      <Paper elevation={3} sx={{ width: '100%', height: '100vh', position: 'relative' }}>

        {/* Wrapper around iframe */}
        <Box sx={{ position: 'relative', height: '100%' }}>

          {/* The iframe for rendering invoice */}
          <iframe
            src={URL.createObjectURL(renderInvoice())}
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
            }}
            title="Invoice Preview"
          />

          {/* Button inside the iframe container */}
          <Box
            sx={{
              position: 'absolute',
              top: 10, // Distance from the top
              right: 409, // Distance from the right
              zIndex: 10,
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleGenerateInvoice}
            >
              Save
            </Button>
          </Box>

          <Box
            sx={{
              position: 'absolute',
              top: 10, // Distance from the top
              right: 280, // Distance from the right
              zIndex: 10,
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleSendEmail}
            >
              Send Email
            </Button>
          </Box>
          <Box
            sx={{
              position: 'absolute',
              top: 10, // Distance from the top
              right: 90, // Distance from the right
              zIndex: 10,
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={downloadInvoice}
            >
              Download Invoice
            </Button>
          </Box>

        </Box>

      </Paper>
    </Box>
  );
};

export default PreviewPage;
